import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MicroFirmlyApprovedComponent } from './micro-firmly-approved/micro-firmly-approved.component';

const routes: Routes = [
  {
    path: 'micro-firmly-approved',
    component: MicroFirmlyApprovedComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class ShowcasesDealsRoutes { }
